/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Locked_ToastInputs */



/**
* | output |
* | --- |
* | "This event group is locked and cannot be edited." |
*
* @param {Event_Group_Locked_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_locked_toast = /** @type {((inputs?: Event_Group_Locked_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Locked_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("This event group is locked and cannot be edited.")
	if (locale === "de") return /** @type {LocalizedString} */ ("This event group is locked and cannot be edited.")
	if (locale === "it") return /** @type {LocalizedString} */ ("This event group is locked and cannot be edited.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("This event group is locked and cannot be edited.")
	if (locale === "es") return /** @type {LocalizedString} */ ("This event group is locked and cannot be edited.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("This event group is locked and cannot be edited.")
	if (locale === "ja") return /** @type {LocalizedString} */ ("This event group is locked and cannot be edited.")
	if (locale === "hi") return /** @type {LocalizedString} */ ("This event group is locked and cannot be edited.")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("This event group is locked and cannot be edited.")
	return /** @type {LocalizedString} */ ("This event group is locked and cannot be edited.")
});